export const CUSTOMERS_OVERVIEWS_PAGE_SIZE = 100_000;
